import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sessionPing } from '../lib/api';

function needsSessionKeepAlive(pathname: string): boolean {
  if (pathname === '/admin' || pathname.startsWith('/admin/')) return true;
  if (pathname === '/home' || pathname.startsWith('/home/')) return true;
  return false;
}

/** Refreshes the HTTP-only session cookie when returning to the app or landing on authenticated routes. */
export function SessionKeepAlive() {
  const loc = useLocation();

  useEffect(() => {
    if (!needsSessionKeepAlive(loc.pathname)) return;

    const bump = () => {
      if (document.visibilityState !== 'visible') return;
      void sessionPing();
    };

    void sessionPing();
    document.addEventListener('visibilitychange', bump);
    window.addEventListener('focus', bump);
    return () => {
      document.removeEventListener('visibilitychange', bump);
      window.removeEventListener('focus', bump);
    };
  }, [loc.pathname]);

  return null;
}
